import React, { useState, useEffect } from 'react';
import { Form, Button, Table, Alert } from 'react-bootstrap';
import { searchPostageAccounts } from '../services/api';

function PostageAccountSearch() {
    const [searchParams, setSearchParams] = useState({
        id: '',
        postageAccountNumber: '',
        ownerNetId: '',
        authorizedUserNetId: '',
        department: '',
        worktag: ''
    });
    const [results, setResults] = useState([]);
    const [error, setError] = useState('');
    const [errorTimeout, setErrorTimeout] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const filteredParams = Object.fromEntries(Object.entries(searchParams).filter(([_, v]) => v !== ''));
        clearTimeout(errorTimeout); // Clear any existing error timeout
        try {
            const accounts = await searchPostageAccounts(filteredParams);
            setResults(accounts);
            setError('');
        } catch (error) {
            setError('Failed to fetch search results: ' + error.message);
            const timeout = setTimeout(() => {
                setError('');
            }, 5000);
            setErrorTimeout(timeout);
        }
    };

    useEffect(() => {
        return () => clearTimeout(errorTimeout);
    }, [errorTimeout]);

    return (
        <div className="container mt-3">
            <div className="page-header"><h1 className="gradient-under">Postage Account Search</h1></div>
            <h2 className='h5 mb-3'>Find an existing Postage Account</h2>
            <p className='mb-4'>You may search existing Postage Accounts by any of the following criteria. Multiple fields may be used, but a postage account must satisfy all criteria submitted to be found. Any field left blank will not be considered as a search parameter.</p>
            <p></p>
            <Form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <Form.Group className="mb-3">
                            <Form.Label>Postage Account Number</Form.Label>
                            <Form.Control type="text" name="postageAccountNumber" value={searchParams.postageAccountNumber} onChange={handleChange} />
                        </Form.Group>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <Form.Group className="mb-3">
                            <Form.Label>Owner Net ID</Form.Label>
                            <Form.Control type="text" name="ownerNetId" value={searchParams.ownerNetId} onChange={handleChange} />
                        </Form.Group>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <Form.Group className="mb-3">
                            <Form.Label>Authorized User Net ID</Form.Label>
                            <Form.Control type="text" name="authorizedUserNetId" value={searchParams.authorizedUserNetId} onChange={handleChange} />
                        </Form.Group>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <Form.Group className="mb-3">
                            <Form.Label>Department</Form.Label>
                            <Form.Control type="text" name="department" value={searchParams.department} onChange={handleChange} />
                        </Form.Group>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <Form.Group className="mb-3">
                            <Form.Label>Worktag / Worktag String</Form.Label>
                            <Form.Control type="text" name="worktag" value={searchParams.worktag} onChange={handleChange} />
                        </Form.Group>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-end'>
                        <div className='d-flex flex-row justify-content-center'>
                            <div>
                                <Button type="submit" className="mb-3">Search Postage Accounts</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
            <hr />


            {error && <Alert variant="danger">{error}</Alert>}
            {results.length > 0 && (
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Account Number</th>
                            <th>Department</th>
                            <th>Worktag String</th>
                            <th>Owner (NetId)</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map(account => (
                            <tr key={account.id}>
                                <td>{account.postageAccountNumber}</td>
                                <td>{account.department}</td>
                                <td>{account.worktagString}</td>
                                <td>{account.owner ? `${account.owner.firstName} ${account.owner.lastName} (${account.owner.netId})` : 'No owner assigned'}</td>
                                <td><a href={`/postage-account/${account.postageAccountNumber}`}>View Details</a></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default PostageAccountSearch;
